module.exports = __webpack_public_path__ + "static/media/playstore.ef9ef08d.png";